// 1:1 port from age-of-mcp v3 chest — an oversized lockbox: one fat plank-wood
// trunk with a darker lid cracked open toward the back, two steel straps
// wrapping body and lid, and a gold lock plate on the front as the glint the
// camera catches from above.
import { defineModel, styleV3, type Part } from "../../lib";

const { WOOD, WOOD_DK, STEEL, STONE_DK, ROOF_PRECIOUS, box, slab, poles } = styleV3;

const BASE  = 0.04;           // a thin pad, not a full building slab
const LID_T = -0.22;          // lid tilt (cracked open around its back edge)

function pad(): Part {
  return slab(0.42, 0.34, STONE_DK, BASE);
}

// The trunk body, full size.
function body(): Part {
  return box(0.4, 0.2, 0.3, WOOD, [0, BASE + 0.1, 0]);
}

function partsFor(s: number): Part[] {
  if (s <= 0) return [pad()];
  if (s === 1) return [pad(), box(0.4, 0.08, 0.3, WOOD_DK, [0, BASE + 0.04, 0]), ...poles(0.44, 0.36, 0.26)];
  if (s === 2) return [pad(), body(), ...poles(0.44, 0.36, 0.3)];

  return [
    pad(),
    body(),
    // The lid, cracked open around its back edge.
    box(0.42, 0.09, 0.32, WOOD_DK, [0, 0.285, -0.015], [LID_T, 0, 0]),
    // Steel straps wrapping the body front and riding over the lid.
    box(0.05, 0.21, 0.02, STEEL, [-0.11, BASE + 0.105, 0.155]),
    box(0.05, 0.21, 0.02, STEEL, [0.11, BASE + 0.105, 0.155]),
    box(0.05, 0.02, 0.33, STEEL, [-0.11, 0.335, -0.015], [LID_T, 0, 0]),
    box(0.05, 0.02, 0.33, STEEL, [0.11, 0.335, -0.015], [LID_T, 0, 0]),
    // The gold lock plate.
    box(0.07, 0.07, 0.03, ROOF_PRECIOUS, [0, BASE + 0.19, 0.16]),
  ];
}

export const chestV3 = defineModel({
  id: "chest-v3",
  tiles: { w: 1, h: 1 },
  batchId: "45-optimized",
  name: "Chest (v3)",
  tags: ["building","chest","low-poly","age-of-mcp","v3"],
  summary: "Low-poly chest.",
  description: "A sturdy wooden lockbox for storing a small amount of goods.",
  author: "age-of-mcp",
  footprint: 0.36,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => partsFor(0) },
    { id: "stage-1", label: "Lower", parts: () => partsFor(1) },
    { id: "stage-2", label: "Upper", parts: () => partsFor(2) },
    { id: "complete", label: "Complete", parts: () => partsFor(3) },
  ],
  animations: [],
});
